import React, { useState, useEffect } from "react";
import { withRouter } from "../../../providers/withRouter";
import { useTranslation } from "react-i18next";
/* import LogoMC from "../../../images/MC.png" */
import LogoLAE from "../../../images/LogoLAE.png"
import salida from "../../../images/salida.png"
import salidaEmergencia from "../../../images/salidaEmergencia.png"
import riesgosElectricos from "../../../images/riesgosElectricos.png"
import { getFinca, getSale, getVisitSheet } from "../../../services";
import { formatoFechasEs } from "../../../functions/funciones";


const EvaluacionRiesgosRender = (props) => {
    const { t } = useTranslation('pdfs');

    const [finca, setFinca] = useState({})
    const fetchData = async () => {
       try {
        const response = await getFinca(props.params.nif)
        let finca = response
        const respSale = await getSale(props.params.id);
        const visitSheet_id = respSale.detailsCae[0].visitSheet_id;
        const respVisit = await getVisitSheet(visitSheet_id)
        finca.imgURL = `${process.env.REACT_APP_STORAGE_URL}${response.visitSheets[0].img}`
        finca.fechaVisita = formatoFechasEs(finca.visitSheets[0].createdAt)
        setFinca(response)
       } catch (error) {
        alert(error)
       }
    }

    useEffect(() =>{
        fetchData();
    },[])

    return ( 
        <>
            <table className="tablePage">
                <thead><tr><td>
                    <div className="header-space">&nbsp;</div>
                </td></tr></thead>
                <tbody>
                    <h1>{t('riskAssessment.title')}</h1>
                    <h2><b>{t('riskAssessment.communityOfOwners')}</b> {finca?.razonSocial}</h2>
                    <h2><b>{t('riskAssessment.workCenter')}</b> {finca?.direccion}</h2>
                    <h2><b>{t('riskAssessment.date')}</b> {finca?.fechaVisita}</h2>
                    <div id="imgFinca" style={{ width: '100%', paddingTop: '66.66%', backgroundImage: `url("${finca?.imgURL}")`, backgroundPosition: 'center', backgroundSize: 'cover', marginTop: 100 }}></div>
                    <div className="pagebreak"></div>
                    <h3>{t('riskAssessment.introduction')}</h3>
                    <p>
                        {t('riskAssessment.intro.text1', { name: finca?.razonSocial })}<br />
                        {t('riskAssessment.intro.text2')}<br />
                    </p>
                    <h3>{t('riskAssessment.methodology')}</h3>
                    <p>
                        {t('riskAssessment.methodologyTexts.text1')}<br />
                        {t('riskAssessment.methodologyTexts.text2')}<br />
                        {t('riskAssessment.methodologyTexts.text3')}<br />
                    </p>
                    {/* eslint-disable-next-line */}
                    {/* <img src={evRiesg_1} style={{ width: '70%', margin: '0 15% 24px 15%' }} /> */}
                    
                    <h3>{t('riskAssessment.communityData')}</h3>
                    <p>{t('riskAssessment.communityOfOwnersLabel')} {finca?.razonSocial}</p>
                    <p>{t('riskAssessment.addressLabel')} {finca?.direccion}</p>
                    <p>{t('riskAssessment.localityLabel')} {finca?.localidad}</p>
                    <p>{t('riskAssessment.cifLabel')} {finca?.nif}</p>
                    <p>{t('riskAssessment.sectorLabel')} {t('riskAssessment.sectorValue')}</p>
                    <p>{t('riskAssessment.workCenterAnalyzed')} {finca?.direccion}, {finca?.codigoPostal}, {finca?.localidad}</p>
                    <h3>{t('riskAssessment.riskIdentificationData')}</h3>
                    <p>{t('riskAssessment.dateOfCompletion')} {finca?.fechaRealizacion}</p>
                    {/* <div className="pagebreak"></div> */}
                    {/* <h3>3. Severidad / Probabilidad</h3> */}
                    {/* eslint-disable-next-line */}
                    {/* <img src={evRiesg_2} style={{ width: '100%', marginBottom: 24 }} /> */}
                    {/* <div className="pagebreak"></div> */}
                    {/* <h3>4. Valor del riesgo / prioridad</h3> */}
                    {/* eslint-disable-next-line */}
                    {/* <img src={evRiesg_3} style={{ width: '100%', marginBottom: 24 }} /> */}
                    <div className="pagebreak"></div>
                    {/* <h3>7. Identificación de riesgos</h3>
                    <p>A continuación, se detallan a modo de resumen los distintos elementos requeridos por los trabajadores.</p> */}
                    <h3>{t('riskAssessment.riskIdentificationTitle')}</h3>
                    <p>
                        {t('riskAssessment.riskIdentificationIntro.text1')}<br />
                        {t('riskAssessment.riskIdentificationIntro.text2')}<br />
                    </p>
                    <table className="tableRiesgos">
                        <tbody>
                            <tr>
                                <th>{t('riskAssessment.table.riskDescription')}</th>
                                <th>{t('riskAssessment.table.origin')}</th>
                                <th>{t('riskAssessment.table.riskAssessment')}</th>
                                <th>{t('riskAssessment.table.proposedMeasure')}</th>
                            </tr>
                            {finca?.p1_2 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p1_2')}</td>
                                </tr>
                                : null}
                            {finca?.p1_1 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p1_1')}</td>
                                </tr>
                                : null}
                            {finca?.p3_4 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p3_4_general')}</td>
                                </tr>
                                : null}
                            {finca?.p1_4 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.electricalContacts')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p1_4')}</td>
                                </tr>
                                : null}
                            {finca?.p1_5 === 's' ?
                                <tr>
                                    <td><span dangerouslySetInnerHTML={{ __html: t('riskAssessment.riskTypes.electricalContactsOpenBoxes') }} /></td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p1_5')}</td>
                                </tr>
                                : null}
                            {/* {finca?.p1_5 === 's' ?
                                <tr>
                                    <td>Contactos eléctricos</td>
                                    <td>General</td>
                                    <td>Moderado</td>
                                    <td>Cerrar y tapar con su respectiva caja y adecuadamente el cuadro eléctrico </td>
                                </tr>
                                : null} */}
                            {finca?.p1_6 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallsDistinctLevel')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p1_6')}</td>
                                </tr>
                                : null}
                            {finca?.p1_7 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.electricalContacts')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p1_7')}</td>
                                </tr>
                                : null}
                            {finca?.p1_8 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.electricalContacts')}</td>
                                    <td>{t('riskAssessment.origins.general')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p1_8')}</td>
                                </tr>
                                : null}
                            {finca?.p2_1 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p2_1')}</td>
                                </tr>
                                : null}
                            {finca?.p2_2 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p2_2')}</td>
                                </tr>
                                : null}
                            {finca?.p2_3 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_3')}</td>
                                </tr>
                                : null}
                            {finca?.p2_4 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_4')}</td>
                                </tr>
                                : null}
                            {finca?.p2_6 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_6')}</td>
                                </tr>
                                : null}
                            {finca?.p2_5 === 'n' ?
                                <tr>
                                    <td></td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_5')}</td>
                                </tr>
                                : null}
                            {finca?.p2_7 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.electricalContact')}</td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p2_7')}</td>
                                </tr>
                                : null}
                            {finca?.p2_8 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_8')}</td>
                                </tr>
                                : null}
                            {finca?.p2_9 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p2_9')}</td>
                                </tr>
                                : null}
                            {finca?.p2_10 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.entrapments')}</td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p2_10a')}</td>
                                </tr>
                                : null}
                            {finca?.p2_10 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.entrapments')}</td>
                                    <td>{t('riskAssessment.origins.elevators')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p2_10b')}</td>
                                </tr>
                                : null}
                            {finca?.p3_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p3_1a')}</td>
                                </tr>
                                : null}
                            {finca?.p3_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p3_1b')}</td>
                                </tr>
                                : null}
                            {finca?.p3_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p3_2')}</td>
                                </tr>
                                : null}
                            {finca?.p3_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p3_3a')}</td>
                                </tr>
                                : null}
                            {finca?.p3_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p3_3b')}</td>
                                </tr>
                                : null}
                            {/* {finca?.p3_3 === 'n' ?
                                <tr>
                                    <td>Caída de personal a diferente nivel</td>
                                    <td>Azotea</td>
                                    <td>Importante</td>
                                    <td>Proporcionar a los trabajadores arnés de seguridad, cuerdas de seguridad y punto de amarre seguro para los trabajos en la zona de la azotea</td>
                                </tr>
                                : null} */}
                            {finca?.p3_4 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.rooftop')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p3_4')}</td>
                                </tr>
                                : null}
                            {finca?.p4_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_1')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2a')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2b')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2c')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2d')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2e')}</td>
                                </tr>
                                : null}
                            {finca?.p4_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_2f')}</td>
                                </tr>
                                : null}
                            {finca?.p4_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p4_3')}</td>
                                </tr>
                                : null}
                            {finca?.p4_4 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p4_4')}</td>
                                </tr>
                                : null}
                            {finca?.p4_6 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_6')}</td>
                                </tr>
                                : null}
                            {finca?.p4_7 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_7')}</td>
                                </tr>
                                : null}
                            {finca?.p4_8 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_8')}</td>
                                </tr>
                                : null}
                            {finca?.p4_9 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p4_9a')}</td>
                                </tr>
                                : null}
                            {finca?.p4_9 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p4_9b')}</td>
                                </tr>
                                : null}
                            {finca?.p4_10 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p4_10')}</td>
                                </tr>
                                : null}
                            {finca?.p4_11 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p4_11')}</td>
                                </tr>
                                : null}
                            {finca?.p4_12 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p4_12')}</td>
                                </tr>
                                : null}
                            {finca?.p4_13 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_13')}</td>
                                </tr>
                                : null}
                            {finca?.p4_14 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_14')}</td>
                                </tr>
                                : null}
                            {finca?.p4_15 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_15')}</td>
                                </tr>
                                : null}
                            {finca?.p4_16 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p4_16')}</td>
                                </tr>
                                : null}
                            {finca?.p4_17 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.electricalContacts')}</td>
                                    <td>{t('riskAssessment.origins.parking')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p4_17')}<br />
                                        <img src={riesgosElectricos} alt="riesgos electrícos" />
                                    </td>
                                </tr>
                                : null}
                            {finca?.p5_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                    <td>{t('riskAssessment.origins.garden')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p5_2')}</td>
                                </tr>
                                : null}
                            {finca?.p5_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                    <td>{t('riskAssessment.origins.garden')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p5_3a')}</td>
                                </tr>
                                : null}
                            {finca?.p5_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                    <td>{t('riskAssessment.origins.garden')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p5_3b')}</td>
                                </tr>
                                : null}
                            {finca?.p5_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                    <td>{t('riskAssessment.origins.garden')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p5_3c')}</td>
                                </tr>
                                : null}
                            {finca?.p6_1 === 's' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                    <td>{t('riskAssessment.origins.pool')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p6_1')}</td>
                                </tr>
                                : null}
                            {finca?.p6_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.pool')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p6_2a')}</td>
                                </tr>
                                : null}
                            {finca?.p6_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                    <td>{t('riskAssessment.origins.pool')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p6_2b')}</td>
                                </tr>
                                : null}
                            {finca?.p6_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.pool')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p6_3')}</td>
                                </tr>
                                : null}
                            {finca?.p7_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.gasInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p7_1')}</td>
                                </tr>
                                : null}
                            {finca?.p7_1 === 'n' || finca?.p7_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.gasInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p7_1_2')}</td>
                                </tr>
                                : null}
                            {finca?.p7_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.explosions')}</td>
                                    <td>{t('riskAssessment.origins.gasInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p7_3')}</td>
                                </tr>
                                : null}
                            {finca?.p8_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.dieselInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p8_1')}</td>
                                </tr>
                                : null}
                            {finca?.p8_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.dieselInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p8_2')}</td>
                                </tr>
                                : null}
                            {finca?.p8_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.others')}</td>
                                    <td>{t('riskAssessment.origins.dieselInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p8_3')}</td>
                                </tr>
                                : null}
                            {finca?.p8_4 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.dieselInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p8_4')}</td>
                                </tr>
                                : null}
                            {finca?.p8_5 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.dieselInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p8_5')}</td>
                                </tr>
                                : null}
                            {finca?.p9_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.cityGasInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p9_1')}</td>
                                </tr>
                                : null}
                            {finca?.p9_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.cityGasInstallation')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p9_2')}</td>
                                </tr>
                                : null}
                            {finca?.p10_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.important')}</td>
                                    <td>{t('riskAssessment.measures.p10_1')}</td>
                                </tr>
                                : null}
                            {finca?.p10_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p10_2')}</td>
                                </tr>
                                : null}
                            {finca?.p10_3 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p10_3')}</td>
                                </tr>
                                : null}
                            {finca?.p10_4 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p10_4')}</td>
                                </tr>
                                : null}
                            {finca?.p10_5 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p10_5')}</td>
                                </tr>
                                : null}
                            {finca?.p10_6 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.extinguishers')}</td>
                                    <td>{t('riskAssessment.riskValues.moderate')}</td>
                                    <td>{t('riskAssessment.measures.p10_6')}</td>
                                </tr>
                                : null}
                            {finca?.p11_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.lighting')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p11_1')}</td>
                                </tr>
                                : null}
                            {finca?.p11_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.lighting')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p11_2')}</td>
                                </tr>
                                : null}
                            {finca?.p12_1 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.signage')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p12_1')}<br />
                                        <img src={salida} alt="Salida" />
                                    </td>
                                </tr>
                                : null}
                            {finca?.p12_2 === 'n' ?
                                <tr>
                                    <td>{t('riskAssessment.riskTypes.fires')}</td>
                                    <td>{t('riskAssessment.origins.signage')}</td>
                                    <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                    <td>{t('riskAssessment.measures.p12_2')}<br />
                                        <img src={salidaEmergencia} alt="Salida de emergencia" />
                                    </td>
                                </tr>
                                : null}
                        </tbody>
                    </table>
                    {finca?.p13_0 === 's' ?
                        <>
                            <h3>{t('riskAssessment.workersSection.title')}</h3>
                            <table className="tableRiesgos">
                                <tbody>
                                    <tr>
                                        <th>{t('riskAssessment.table.riskDescription')}</th>
                                        <th>{t('riskAssessment.table.origin')}</th>
                                        <th>{t('riskAssessment.table.riskAssessment')}</th>
                                        <th>{t('riskAssessment.table.preventiveAction')}</th>
                                    </tr>
                                    {finca?.p13_1 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_1')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_2 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_2')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3c')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.forcedPostures')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3d')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3e')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_3 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_3f')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_4 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_4a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_4 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_4b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_4 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_4c')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_4 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_4d')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_5 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_5')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_6 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.electricalContacts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_6')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_7 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallsDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_7')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_8 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_8a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_8 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_8b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_9 === 's' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_9')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_10 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_10')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_11 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_11a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_11 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.workersSection.unknown')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_11b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_12 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_12a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_12 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_12b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_13 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalExposure')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_13')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_14 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalContact')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_14')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_15 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalContact')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_15a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_15 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalContact')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_15b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_15 === 'n' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.chemicalContact')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_15c')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_16 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_16a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_16 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_16b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_16 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_16c')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_16 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_16d')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_16 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_16e')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_17 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_17a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_17 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_17b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_17 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.hitsAndCuts')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_17c')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_18 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.important')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_18a')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_18 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_18b')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_18 === 's' ?
                                        <tr>
                                            <td>{t('riskAssessment.riskTypes.fallDifferentLevel')}</td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_18c')}
                                                <ul>
                                                    <li>{t('riskAssessment.workersSection.p13_18c_li1')}</li>
                                                    <li>{t('riskAssessment.workersSection.p13_18c_li2')}</li>
                                                    <li>{t('riskAssessment.workersSection.p13_18c_li3')}</li>
                                                    <li>{t('riskAssessment.workersSection.p13_18c_li4')}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        : null}
                                    {finca?.p13_19 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_19')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_20 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.moderate')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_20')}</td>
                                        </tr>
                                        : null}
                                    {finca?.p13_21 === 'n' ?
                                        <tr>
                                            <td></td>
                                            <td>{t('riskAssessment.origins.worker')}</td>
                                            <td>{t('riskAssessment.riskValues.tolerable')}</td>
                                            <td>{t('riskAssessment.workersSection.p13_21')}</td>
                                        </tr>
                                        : null}
                                </tbody>
                            </table>
                        </>
                        : null}
                    <h3>{t('riskAssessment.conclusion.title')}</h3>
                    <p>
                        {t('riskAssessment.conclusion.text')} <span style={{textTransform:"capitalize"}}>{finca?.tecnico?.nombre}</span>{t('riskAssessment.conclusion.techRole')} <br />
                    </p>
                </tbody>
            </table>
            <div className="pdf-header">
                <img src={LogoLAE} alt="Logo LAE" />
                {/* <img src={LogoMC} alt="Logo MC" /> */}
            </div>
            <style jsx>{`
            .tablePage{
                width: 100%;
            }
            .pdf-header {
                width: 100%;
                display: flex;
                justify-content: space-between;
                position: fixed;
                top: 0;
                left:50%
                background-color: #ffffff
            }
            .header-space, .pdf-header {
                height: 90px;
                
            }
            .pdf-header img {
                height: 60px
            }
            div {
                font-size: 10px
            }
            h1 {
                margin-top: 100px;
                margin-bottom: 60px;
                font-size: 20px;
            }
            h2 {
                font-size: 18px;
                font-weight: 400;
            }
            h3 {
                width: 100%;
                padding: 5px 10px;
                background-color: #f8f8f8;
                text-transform: uppercase;
                border: 1px solid #e6e6e6;
                margin-top: 25px;
                margin-bottom: 15px;
            }
            .tableRiesgos {
                border-collapse: collapse;
                width: 100%;
                table-layout: fixed;
                margin-bottom: 24px;
                
            }
            .tableRiesgos th, .tableRiesgos td {
                border: 1px solid #000000;
                padding: 5px;
                line-height: 1.1;
                text-align: justify;
            }
            .tableRiesgos th {
                background-color: #375491;
                color: #ffffff;
                font-size: 12px;
                font-weight: bold;
            }
            p {
                line-height: 1.8;
                text-align: justify;
            }
            br {
                display: block;
                margin: 24px 0;
                line-height:22px;
                content: " ";
            }
            @page {
                size: A4 portrait;
                margin: 2cm
            }
        `}</style>
        </>
     );
}

export default withRouter(EvaluacionRiesgosRender);